import { TOGGLE_LAYER_VISIBILITY_BY_ID } from "../store/mutations.type";
import { FETCH_BACKGROUND_LAYERS, MAKE_BACKGROUND_LAYER_VISIBLE } from "../store/actions.type";

const state = {
  layers: []
}

const actions = {
  [FETCH_BACKGROUND_LAYERS](context) {
    state.layers = context.rootGetters.backgroundGroupLayers;
  },
  [MAKE_BACKGROUND_LAYER_VISIBLE]({ commit }, layerId) {
    const visibleLayer = state.layers.find(l => l.visible);

    if (visibleLayer) {
      commit(TOGGLE_LAYER_VISIBILITY_BY_ID, visibleLayer.id);
    }

    commit(TOGGLE_LAYER_VISIBILITY_BY_ID, layerId);
  }
}

const getters = {
  backgroundLayers: (state) => state.layers
}

export default {
  state,
  actions,
  getters
}